import React, { useState } from 'react';
import { Card, CardContent as CardBody } from '@shadcn/components/ui/card';
import { useHistory } from 'react-router-dom';
import SupplyChainNav from '../../../components/supply-chain/nav.js';


import MispickReportPage from '../mispick-report/index.js';
import OrderCycleTimeDashboard from '../order-cycle-time/index.js';
import NestedOrderRate from '../nested-order-rate/index.js';
import ShippedOrdersReport from '../shipped-orders-report/index.js';

const reportNavMenu = {
  'order-report': [
    {
      name: 'Shipped Orders',
      url: '/order-report/shipped-orders',
      lookup: '/order-report/shipped-orders',
    },
    {
      name: 'Mispick Report',
      url: '/order-report/mispick',
      lookup: '/order-report/mispick',
    },
    {
      name: 'Order Cycle Time',
      url: '/order-report/cycle-time',
      lookup: '/order-report/cycle-time',
    },
    {
      name: 'Nested Order Rate',
      url: '/order-report/nested-rate',
      lookup: '/order-report/nested-rate',
    },
  ]
};


const OrderReportDashboard = () => {
  const history = useHistory();
  
  
  const navBarMenu = {
    'order-report': reportNavMenu['order-report']
  };

  
  React.useEffect(() => {
    window.navBarMenu = navBarMenu;
  }, []);

  return (
    <SupplyChainNav menuType="order-report">
      <Card className="pt-6 mb-10">
        <CardBody className="flex-1 min-h-0">
          {history?.location?.pathname?.includes('order-report/shipped-orders') && (
            <ShippedOrdersReport />
          )}
          
          {history?.location?.pathname?.includes('order-report/mispick') && (
            <MispickReportPage />
          )}

          
          {history?.location?.pathname?.includes('order-report/cycle-time') && (
            <OrderCycleTimeDashboard />
          )}

          
          {history?.location?.pathname?.includes('order-report/nested-rate') && (
            <NestedOrderRate />
          )}

          
          {!history?.location?.pathname?.includes('order-report/shipped-orders') &&
           !history?.location?.pathname?.includes('order-report/mispick') && 
           !history?.location?.pathname?.includes('order-report/cycle-time') && 
           !history?.location?.pathname?.includes('order-report/nested-rate') && (
            <div className="p-4 text-center">
              <h2 className="text-xl font-semibold mb-4">Order Reports Dashboard</h2>
              <p>Please select a report from the sidebar to view detailed information.</p>
            </div>
          )}
        </CardBody>
      </Card>
    </SupplyChainNav>
  );
};

export default OrderReportDashboard;
